module.exports = __webpack_public_path__ + "static/media/grid_selected.5b122218.svg";